class DRGService {

  constructor($http, $rootScope) {
    if ($rootScope && $rootScope.globals)
        $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
    this.$http = $http;
  }

  getSpecialties() {
    return this.$http.get('' + WEBSERVICEURL + '/dataagility/api/service.refcode/queryall?domain=SPECIAL');
  }

  getSpecialtyDesc(specialtyId) {
    return this.$http.get('' + WEBSERVICEURL + '/dataagility/api/service.refcode/' + specialtyId);
  }

  getDRG(wiesVer) {
    return this.$http.get('' + WEBSERVICEURL + '/dataagility/api/service.wies/findbywiesversion?ver='+ wiesVer);
  }

  putDRG(specialtyId, data) {
    return this.$http.put(WEBSERVICEURL + '/dataagility/api/service.wies/' + specialtyId + '/', data);
  }

  getDistinctWIES() {
    return this.$http.get('' + WEBSERVICEURL + '/dataagility/api/service.wies/distinctwies');
  }

}

class DrgsController {
  constructor($http, $scope, LxDialogService, Constants, CONST, $rootScope, $location, FunctionService, $sanitize) {

    $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
    this.name = 'DRG';
    this.episodeValue = '';
    this.specialtyString = '';
    this.options = {
      removeChromeAutoComplete: true
    };

    this.form = "drg";

    this.DRGOptions = [];
    this.DRG = {
      selectedDRG: null
    };

    this.WIESVEROptions = [];
    this.WIESVER = {
      selectedWIESVER: null
    };

    this.specialty = {
      selectedSpecialty: []
    };
    this.specialty.specialtyOptions = [];

    this.roles = {
      selectedRole: undefined
    };
    this.roles.rolesOptions = CONST.ROLE;

    this.model = {};

    Constants.getDivisionAndSpecialtyData().then(
        function successCallback(response) {
            $scope.vm.specialtyOptions = response.specialties;
        }
    );

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
          $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
          $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
      }
  );

    // Setup WIESVER Select
    new DRGService($http, $scope).getDistinctWIES()
    .then(

      function successCallback(response) {

        angular.forEach(response.data, function(value, key) {
          $scope.vm.WIESVEROptions.push(value);
        });

        $scope.vm.WIESVER.selectedWIESVER = $scope.vm.WIESVEROptions[0];
        setupDRG($scope.vm.WIESVER.selectedWIESVER.wiesVersion);

      },
      function errorCallback(response) {
        if (response.status === 401) {
          window.location.replace(window.location.origin + '/login?logout=true');
        }
      }
    );

    function setupDRG(wiesVer) {
      // Setup DRG Select
      new DRGService($http, $scope).getDRG(wiesVer)
      .then(

        function successCallback(response) {

          // reset DRG options
          if ( $scope.vm.DRGOptions )
            $scope.vm.DRGOptions = [];

          angular.forEach(response.data, function(value, key) {
            value.comments = $sanitize(value.comments);
            $scope.vm.DRGOptions.push(value);
          });

          $scope.vm.DRG.selectedDRG = $scope.vm.DRGOptions[0];

        },
        function errorCallback(response) {
          if (response.status === 401) {
            window.location.replace(window.location.origin + '/login?logout=true');
          }
        }
      );
    }

    // Setup Specialties Select options
    new DRGService($http, $scope).getSpecialties()
    .then(

      function successCallback(response) {
        angular.forEach(response.data, function(value, key) {
          value['comments'] = $sanitize(value.comments);
          value['groupName'] = $sanitize(value.groupName);
          value['description'] = $sanitize(value.description);
          if (value['description']) {
            $scope.vm.specialty.specialtyOptions.push(value);
          }
        });

        // $scope.vm.specialty.selectedspecialty = $scope.vm.specialtyOptions[0];

      },
      function errorCallback(response) {
        if (response.status === 401) {
          window.location.replace(window.location.origin + '/login?logout=true');
        }
      }
    );

    this.DRGCallback = DRGCallback;
    this.specialtyCallback = specialtyCallback;
    this.WIESVERCallback = WIESVERCallback

    function WIESVERCallback(_newValue, _oldValue) {

      if (_newValue != _oldValue && _oldValue)
        setupDRG($scope.vm.WIESVER.selectedWIESVER.wiesVersion);

    }

    function DRGCallback(_newValue, _oldValue) {

      if (!$scope.vm.DRG.selectedDRG)
        return;

      if ( $scope.vm.DRG.selectedDRG !== $scope.vm.model )
        angular.copy($scope.vm.DRG.selectedDRG, $scope.vm.model);

      var spec,
          specialtyArr = $scope.vm.DRG.selectedDRG.targetedSpecialties;

      if (specialtyArr) {

          spec = specialtyArr.split(',');

      } else {

          spec = [];

      }

      $scope.vm.specialty.selectedSpecialty = [];

      angular.forEach(spec, function(value, key) {

        // GET Specialty description
        new DRGService($http, $scope).getSpecialtyDesc(value)
        .then(

          function successCallback(response) {

            var sanitizedDesc = $sanitize(response.data.description);
            if (sanitizedDesc) {
              $scope.vm.specialty.selectedSpecialty.push( {"refCodeId": parseInt(value), "description": sanitizedDesc } );
            }
          },
          function errorCallback(response) {
            if (response.status === 401) {
              window.location.replace(window.location.origin + '/login?logout=true');
            }
          }
        );

      });

      // reset listener and form state
      $scope.vm.form.$setPristine();
      $scope.vm.form.$setValidity();
      $scope.vm.form.$setUntouched();

    }

    function specialtyCallback(_newValue, _oldValue) {

      // Join the selected Specialties for comparison against the current model
      var mappedSpecIds = $scope.vm.specialty.selectedSpecialty.map(function(num) { return num.refCodeId; }).sort(function (a, b) {  return a - b;  }).join(),
          sortedTargetedSpecialties = $scope.vm.model.targetedSpecialties ? $scope.vm.model.targetedSpecialties.split(',').map(Number).sort(function (a, b) {  return a - b;  }).join() : '';

      if ( sortedTargetedSpecialties !== mappedSpecIds )
        $scope.vm.form.$setDirty();

    }

    this.openDialog = function() {
        LxDialogService.open("doubleCheck");
    }

    this.checkValid = function() {

      // dis/enable submit button

      if ( $scope.vm.form.$pristine ) {

        return true;

      } else {

        if (Object.keys($scope.vm.form.$error).length === 0 && $scope.vm.form.$error.constructor === Object) {

          return false;

        } else {

          return true;
        }

      }

    }

    this.submitDRG = function() {

      // add Specialty data
      $scope.vm.model.targetedSpecialties = $scope.vm.specialty.selectedSpecialty.map(function(num) { return parseInt(num.refCodeId); }).sort(function (a, b) {  return a - b;  }).join();

      if ( $scope.vm.model.targetedSpecialties === '' )
        $scope.vm.model.targetedSpecialties = null;

      $scope.putData($scope.vm.model);

    }

    $scope.putData = function(data) {

      var drgId = data.wiesId,
        data = JSON.stringify(data);

      new DRGService($http).putDRG(drgId, data)
        .then(

          function successCallback(response) {

            $scope.vm.DRG.selectedDRG = $scope.vm.model;
            $scope.snackBar('DRG updated');

          },
          function errorCallback(response) {
            if (response.status === 401) {
              window.location.replace(window.location.origin + '/login?logout=true');
            }
          });

    }

    $scope.snackBar = function(message) {

      // upgrade MDI components
      window.componentHandler.upgradeAllRegistered();

      var snackbarContainer = document.querySelector('#specialty__notification');

      var data = {
        message: message,
        timeout: 2000,
        actionHandler: $scope.finaliseCheck,
        actionText: 'test'
      };

      snackbarContainer.MaterialSnackbar.showSnackbar(data);

    }

    this.fields = [
      {
        type: 'lx-switch',
        key: 'target',
        templateOptions: {
          'label': 'Target DRG'
        }
      },
      {
        type: 'lx-input',
        key: 'comments',
        templateOptions: {
          'label': 'Alert / Note',
          'type': 'text'
        }
      }
    ];

  }
}

export default DrgsController;



// WEBPACK FOOTER //
// ./client/app/common/admin/drgs/drgs.controller.js